import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import { T } from '../../traks';

export const PremiumParticipants = (props) => {
    const subject = <T>Special offer for large-scale Aktiedyste</T>

    return (
        <React.Fragment>
            <Row className='premium-green-container'>
                <Col sm="6">
                    <img className='premium-rounded-corners' src='https://static.aktiedysten.dk/imgs/IMG_7898-768x576.jpg' style={{width: "100%"}} alt='premium'/>
                </Col>
                <Col sm="6">
                    <Row>
                        <Col>
                            <h2><T>More than 100 participants?</T></h2>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col>
                        <span><T>Should you engage your entire school in one big game, or would you rather target your local community? There are many great reasons to create large-scale Aktiedyste—and right now we’re offering a special campaign price for the big games.</T></span>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                        <span><T>More than 100 participants =</T></span><strong><T> 6 kr. per participant per month, regardless of the game’s length. Plus, you get 14 days free</T></strong><span><T> to ensure everyone signs up before kickoff.</T></span>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                        <span><T>Click below and let’s find the perfect solution for you together :)</T></span>
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                            <Button className="ml-auto mb-auto mr-2 px-4 py-2 premium-rounded-corners ad_btn_purple" tag="a" href={`mailto:mira@aktiedysten.dk?subject=${props.render_static(subject)}`}><T>Contact us here</T></Button> 
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumParticipants.js